import React, { useState } from "react";
import styles from "../pages copy/Styles/ContactSupport.module.scss";
import StageLayout from "../Layouts/StageLayout";
import supportImage from "../Components copy/assets/Images/supportscreenimage.svg";
import support from "../Components copy/assets/Images/headphones.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ContactSupport() {
  const [completedStages, setcompletedStages] = useState<any>();
  const navigate = useNavigate();
  return (
    <div className={styles.mainWrapperTop}>
      <StageLayout
        completedStages={completedStages}
        stageName={"Support"}
        navigatePath={"/"}
      />

      <div className={styles.mainWrapper}>
        <p className={styles.headerText}>Thank You!</p>
        <p className={styles.subText}>
          Your PAN details have been submitted successfully. Our team will
          contact you shortly for further processing.
        </p>
        <img src={supportImage} className={styles.image} />
        <div className={styles.bottomSectionButtons}>
          <div>
            <Button
              sx={{
                background: "#006779",
                color: "white",
                fontSize: "14px",
                borderRadius: "10px",
                padding: "3px 20px",
                "&:hover": {
                  background: "#006779",
                  color: "white",
                },
              }}
              onClick={() => {
                navigate("/home");
              }}
            >
              Back to homepage
            </Button>
          </div>
          <div>
            <Button
              endIcon={<img src={support} />}
              sx={{
                background: "#EEEFEF",
                color: "#5A6475",
                fontSize: "14px",
                borderRadius: "10px",
                padding: "3px 20px",
                "&:hover": {
                  background: "#EEEFEF",
                  color: "#5A6475",
                },
              }}
              onClick={() => {
                window.open("https://thefirstock.com/contact.html", "_blank");
              }}
            >
              Customer support
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
